<template>
  <div class="rts-login">
    <div class="login-card">
      <div class="login-header">
        <h2 class="login-title">RTS 管理後台</h2>
        <p class="login-subtitle">Real-Time Statistics</p>
      </div>
      <el-form ref="loginForm" :model="form" :rules="rules" label-position="top" @submit.native.prevent="handleLogin">
        <!-- <el-form-item label="手机号码" prop="phone">
          <div class="phone-input">
            <span class="phone-prefix">+852</span>
            <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="8" class="phone-field"></el-input>
          </div>
        </el-form-item> -->
        <!-- <el-form-item label="验证密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入验证密码" show-password></el-input>
        </el-form-item> -->
        <el-form-item prop="passwordVIP">
          <el-input v-model="form.passwordVIP" type="password" placeholder="" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" class="login-btn" @click="handleLogin">
            {{ loading ? '验证中...' : '登 录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { rtsLoginApi } from '@/Api/requestApi'

export default {
  name: 'RtsLogin',
  data() {
    // const validatePhone = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请输入手机号码'))
    //   }
    //   const regExp = /^(4|5|6|7|8|9)\d{7}$/
    //   if (!regExp.test(value)) {
    //     return callback(new Error('请输入正确的8位香港手机号码'))
    //   }
    //   callback()
    // }
    return {
      loading: false,
      form: {
        phone: '',
        password: '',
        passwordVIP: '',
      },
      rules: {
        // phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        // password: [{ required: true, message: '请输入验证密码', trigger: 'blur' }],
        passwordVIP: [{ required: true, message: '請輸入密碼', trigger: 'blur' }],
      },
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        console.log('handleLogin', this.form)
        if (this.form.passwordVIP === 'klm8888') {
          sessionStorage.setItem('rts_token', Date.now())
          sessionStorage.setItem('rts_role', 'super')
          this.$message({ message: '登錄成功', type: 'success', duration: 500 })
          this.$router.push({ path: '/RTS/KLM/dashboard' }).catch(() => {})
          this.loading = false
        } else if (this.form.passwordVIP === 'icaur8881') {
          sessionStorage.setItem('rts_token', Date.now())
          sessionStorage.setItem('rts_role', 'icaur')
          this.$message({ message: '登錄成功', type: 'success', duration: 500 })
          this.$router.push({ path: '/RTS/KLM/dashboard' }).catch(() => {})
          this.loading = false
        } else if (this.form.passwordVIP === 'zeekr8882') {
          sessionStorage.setItem('rts_token', Date.now())
          sessionStorage.setItem('rts_role', 'zeekr')
          this.$message({ message: '登錄成功', type: 'success', duration: 500 })
          this.$router.push({ path: '/RTS/KLM/dashboard' }).catch(() => {})
          this.loading = false
        } else if (this.form.passwordVIP === 'hongqi8883') {
          sessionStorage.setItem('rts_token', Date.now())
          sessionStorage.setItem('rts_role', 'hongqi')
          this.$message({ message: '登錄成功', type: 'success', duration: 500 })
          this.$router.push({ path: '/RTS/KLM/dashboard' }).catch(() => {})
          this.loading = false
        } else {
          this.$message({ message: '密碼錯誤', type: 'warning' })
          setTimeout(() => {
            this.loading = false
          }, 500)
        }
        // try {
        //   const { data } = await rtsLoginApi({
        //     phone: '852 ' + this.form.phone,
        //     password: this.form.password,
        //   })
        //   if (data.code === 200) {
        //     const token = data.data?.token || 'rts_' + Date.now()
        //     sessionStorage.setItem('rts_token', token)
        //     sessionStorage.setItem('rts_phone', '852 ' + this.form.phone)
        //     this.$message({ message: '登录成功', type: 'success' })
        //     this.$router.push({ path: '/RTS/dashboard' })
        //   } else {
        //     this.$message({ message: data.message || '手机号未授权或密码错误', type: 'warning' })
        //   }
        // } catch (err) {
        //   this.$message({ message: '网络错误，请稍候再试', type: 'error' })
        // } finally {
        //   this.loading = false
        // }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.rts-login {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.login-card {
  width: 420px;
  padding: 48px 40px 36px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.login-header {
  text-align: center;
  margin-bottom: 36px;

  .login-title {
    font-size: 26px;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 6px;
    letter-spacing: 2px;
  }

  .login-subtitle {
    font-size: 13px;
    color: #999;
    margin: 0;
    letter-spacing: 3px;
    text-transform: uppercase;
  }
}

.phone-input {
  display: flex;
  align-items: center;

  .phone-prefix {
    width: 54px;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    flex-shrink: 0;
  }

  .phone-field {
    flex: 1;
  }
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  letter-spacing: 4px;
  background: #1a1a2e;
  border-color: #1a1a2e;

  &:hover {
    background: #16213e;
    border-color: #16213e;
  }
}

::v-deep .el-input__inner {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #ddd;
  padding-left: 0;
  font-size: 15px;

  &:focus {
    border-bottom-color: #1a1a2e;
  }
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #333;
}

::v-deep .el-form-item {
  margin-bottom: 28px;
}
</style>
